(() => {
  'use strict';
  function init(root) {
    if (!root || root.dataset.demoReady === 'true') return;
    const cards = [...root.querySelectorAll('[data-demo-card]')];
    const more = root.querySelector('[data-demo-more]');
    const count = root.querySelector('[data-demo-count]');
    const total = root.querySelector('[data-demo-total]');
    const filters = root.querySelector('[data-demo-filters]');
    if (!cards.length || !more || !count || !total) return;
    const initialCount = 16; // Four rows of four cards on desktop.
    let selected = root.dataset.audience || 'all';
    let shown = initialCount;
    function refresh() {
      const matches = cards.filter(card => selected === 'all' || card.dataset.species === selected);
      const visible = new Set(matches.slice(0, shown));
      cards.forEach(card => { card.hidden = !visible.has(card); });
      const remaining = Math.max(0, matches.length - shown);
      more.hidden = remaining === 0;
      more.firstChild.textContent = `Show ${Math.min(4, remaining)} more reviews `;
      count.textContent = `Showing ${Math.min(shown, matches.length)} of ${matches.length} reviews`;
      total.textContent = `${matches.length} reviews`;
      root.querySelectorAll('[data-demo-filter]').forEach(button => {
        button.setAttribute('aria-pressed', String(button.dataset.demoFilter === selected));
      });
      return matches;
    }
    filters?.addEventListener('click', event => {
      const button = event.target.closest('[data-demo-filter]');
      if (!button || !filters.contains(button)) return;
      selected = button.dataset.demoFilter;
      shown = initialCount;
      refresh();
      // A new species starts at its first card, even after swiping the mobile rail.
      root.querySelector('.mpn-demo-reviews__grid')?.scrollTo({left: 0, behavior: 'instant'});
    });
    more.addEventListener('click', () => {
      const previous = shown;
      shown += 4;
      const matches = refresh();
      // Keep keyboard focus in the newly revealed content when the last button disappears.
      if (more.hidden) matches[previous]?.focus({ preventScroll: true });
    });
    refresh();
    if (filters) filters.hidden = false;
    root.dataset.demoReady = 'true';
  }
  function initWithin(scope) {
    if (scope.matches?.('[data-mpn-demo-reviews]')) init(scope);
    scope.querySelectorAll('[data-mpn-demo-reviews]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initWithin(document), { once: true });
  } else {
    initWithin(document);
  }
  document.addEventListener('shopify:section:load', event => initWithin(event.target));
})();
